export function TiremetrixFixErrorsCtrl (
  $uibModalInstance,
  $scope,
  $timeout,
  $translate,
  errors,
  messages,
  tires,
  warnings,
  workshopAPI
) {
  $scope.tires    = tires;
  $scope.warnings = warnings;
  $scope.errors   = errors;

  $scope.tableSettings = {
    columns: [
      {
        classes: 'text-left',
        field  : 'tyre_identification_number',
        header : {
          text: $translate.instant('TIREMETRIX_SPACE.DOT')
        }
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_PAYMENTS_FOUND')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
    static: true
  };

  $scope.onRowClick = function (event) {
    $scope.tire = event.row;
    $scope.flip();
  };

  $scope.defaultSelection = function () {
    if ($scope.tires.length) {
      $scope.tire = $scope.tires[0];

      for (let i = 0; i < $scope.registrationsNeeded; i++) {
        $scope.references.push({
          base_tin: $scope.tire.BaseTIN,
          week: null,
          year: null
        });
      }

      $scope.flip();
    }
  }

  $scope.flip = function () {
    $scope.flipped = !$scope.flipped;
    $scope.$emit('flipModal');
  };

  $scope.update = function (form) {
    workshopAPI.patch('/vehicle_tyre_registration', $scope.tire, 'vehicle_tyre_registration').then(data => {
      messages.show($translate.instant('TIREMETRIX_SPACE.TYRE_REGISTRATIONS_UPDATED'), 'success');

      $uibModalInstance.close();
    }).catch(err => {
      messages.error(err);
    });
  };

  if ($scope.tires.length <= 1) {
    $timeout(() => {
      $scope.defaultSelection();
    });
  }
}